"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Product_1 = __importDefault(require("./Product"));
class SalesByProductData {
    constructor({ label, product, value, quantity, }) {
        this.toJSON = () => ({
            label: this.label,
            product: this.product,
            value: this.value,
            quantity: this.quantity,
        });
        this.label = label;
        this.product = product;
        this.value = value;
        this.quantity = quantity;
    }
}
SalesByProductData.fromJSON = (json) => {
    const { label, product, value, quantity } = Object.assign({}, json);
    if (typeof label !== 'string')
        throw new Error('.label must be a string');
    if (typeof value !== 'number')
        throw new Error('.number must be a number');
    if (typeof quantity !== 'number')
        throw new Error('.quantity must be a number');
    const _product = typeof product !== 'undefined' ? Product_1.default.fromJSON(product) : undefined;
    return new SalesByProductData({
        label,
        product: _product,
        value,
        quantity,
    });
};
exports.default = SalesByProductData;
